module.exports = __webpack_public_path__ + "img/02_check_1.92dd8a24.svg";